import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { FiMoreHorizontal } from "react-icons/fi";
import { Dropdown } from 'react-bootstrap';
import Moment from 'react-moment';
import { TabletOrDesktop, Mobile } from 'utils/responsive';
import TransactionEditModal from 'components/Transactions/TransactionEditModal';
import DataTable from "components/DataTable";
import { showModal, hideModal } from "actions/modalActions";
import { transactionsService } from "services";
import { errorFormating } from "utils/utils";
import { withTranslation } from 'react-i18next';


class TransactionList extends Component {
	constructor(props) {
		super(props);
		this.closeModal = this.closeModal.bind(this);
		this.openEditTransactionModal = this.openEditTransactionModal.bind(this);
		this.openDeleteTransactionModal = this.openDeleteTransactionModal.bind(this);
		this.openAlertModal = this.openAlertModal.bind(this);
	}

	closeModal() {
		this.props.hideModal()
	}

	openEditTransactionModal(transaction) {
		this.props.showModal({
			open: true,
			title: (transaction.type !== 'Manual') ? this.props.t('transactions.viewTransaction') : this.props.t('transactions.editTransaction'),
			style: { width: '420px' },
			content: <TransactionEditModal transaction={transaction} getTransactions={this.props.getTransactions} handleClose={this.closeModal} />,
			closeModal: this.closeModal
		}, 'edit')
	}

	openDeleteTransactionModal(idTransaction) {
		this.props.showModal({
			open: true,
			title: this.props.t('transactions.deleteTransaction'),
			style: { width: '400px' },
			message: this.props.t('transactions.deleteConfirmation'),
			deleteAction: () => this.confirmDelete(idTransaction),
			closeModal: this.closeModal
		}, 'delete')
	}

	openAlertModal(message) {
		this.props.showModal({
			open: true,
			title: this.props.t('transactions.deleteError'),
			style: { width: '400px' },
			message: message,
			closeModal: this.closeModal
		}, 'alert')
	}

	confirmDelete = async (idTransaction) => {
		const response = await transactionsService.remove(idTransaction);

		if (!response.ok) {
			let textError = errorFormating(response);
			this.openAlertModal(textError.id);
		}
		else {
			this.props.getTransactions();
			this.closeModal();
		}
	}

	formatDisplayedValue(transaction) {
		const value = parseFloat(transaction.value).toFixed(2).toString().replace(".", ",");
		return `${value} ${transaction.account.type}`;
	}

	renderSourceCell(transaction) {
		if (transaction.contract) return transaction.contract.name;
		if (transaction.transaction_rule) return transaction.transaction_rule.name;
		if (transaction.type === "Manual") return transaction.type;
		return null;
	}

	getEmptyRowMobile = () => (
		<tr>
			<td colSpan={4} className="no-result">
				Sin resultados
			</td>
		</tr>
	);

	getDropdownActions = (transaction) => {
		const labelAction = (transaction.type !== 'Manual') ? this.props.t('common.view') : this.props.t('common.edit');

		return (
			<Dropdown>
				<Dropdown.Toggle variant="action"><FiMoreHorizontal /></Dropdown.Toggle>
				<Dropdown.Menu>
					<Dropdown.Item as="button" onClick={() => this.openEditTransactionModal(transaction)}>{labelAction}</Dropdown.Item>
					{transaction.type === 'Manual' &&
						(<Dropdown.Item as="button" onClick={() => this.openDeleteTransactionModal(transaction.id)}>{this.props.t('common.delete')}</Dropdown.Item>)
					}
				</Dropdown.Menu>
			</Dropdown>
		);
	}

	getDesktopColumns = () => [
		{
			key: "day",
			header: this.props.t('transactions.columns.date'),
			render: (transaction) => (
				<button
					type="button"
					className="btn-transparent btn-editable"
					onClick={() => this.openEditTransactionModal(transaction)}
				>
					<Moment format="DD/MM/YY">{transaction.day}</Moment>
				</button>
			),
		},
		{
			key: "employee",
			header: this.props.t('transactions.columns.employee'),
			render: (transaction) => (
				<>{transaction.employee.name} {transaction.employee.surname}</>
			),
		},
		{
			key: "account",
			header: this.props.t('transactions.columns.account'),
			render: (transaction) => transaction.account.name,
		},
		{
			key: "value",
			header: this.props.t('transactions.columns.value'),
			className: "td-valor",
			render: (transaction) => this.formatDisplayedValue(transaction),
		},
		{
			key: "type",
			header: this.props.t('transactions.columns.type'),
			render: (transaction) => transaction.type,
		},
		{
			key: "source",
			header: this.props.t('transactions.columns.source'),
			render: (transaction) => this.renderSourceCell(transaction),
		},
	];

	getRowsMobile = () => (this.props.transactions || []).map((transaction, index) => {
		return (
			<Fragment key={transaction.id != null ? transaction.id : index}>
				<tr className="tr-head">
					<td colSpan="4">
						<button type="button" className="btn-transparent btn-editable" onClick={() => this.openEditTransactionModal(transaction)}>
							<span className="label-top"><Moment format="DD/MM/YY">{transaction.day}</Moment> - {transaction.type}</span>
						</button>
					</td>
				</tr>
				<tr className="tr-body">
					<td>
						<span className="label-mini">{this.props.t('transactions.columns.employee')}</span>{transaction.employee.name}  {transaction.employee.surname}
					</td>
					<td>
						<span className="label-mini">{this.props.t('transactions.columns.account')}</span>{transaction.account.name}
					</td>
					<td className="hidden-xs">
						<span className="label-mini">{this.props.t('transactions.columns.source')}</span>
						{transaction.contract && transaction.contract.name}
						{transaction.transaction_rule && transaction.transaction_rule.name}
						{transaction.type === "Manual" && transaction.type}
					</td>
					<td className="td-actions">
						{this.getDropdownActions(transaction)}
					</td>
				</tr>
			</Fragment>
		)
	});

	render() {
		const transactions = this.props.transactions || [];

		return (
			<>
				<Mobile>
					<table className="table table-transactions table-mobile">
						<tbody>
							{transactions.length === 0
								? this.getEmptyRowMobile()
								: this.getRowsMobile()}
						</tbody>
					</table>
				</Mobile>

				<TabletOrDesktop>
					<DataTable
						tableClassName="table-transactions table-hover"
						tableStyle={{ backgroundColor: "#ffffff" }}
						columns={this.getDesktopColumns()}
						rows={transactions}
						rowKey={(row, idx) => (row.id != null ? row.id : idx)}
						emptyMessage={this.props.t('common.noResults')}
						actionsColumn={{
							render: (transaction) => this.getDropdownActions(transaction),
							className: "td-actions",
						}}
						showHeaderSortAffix={false}
					/>
				</TabletOrDesktop>
			</>
		)
	}
}


const mapDispatchToProps = dispatch => ({
	hideModal: () => dispatch(hideModal()),
	showModal: (modalProps, modalType) => {
		dispatch(showModal({ modalProps, modalType }))
	},
})


export default connect(null, mapDispatchToProps)(withTranslation()(TransactionList))
